import { FaIcon } from '@/lib/fa'
import Navigation from '@/modules/drivers/modals/shared/Navigation'
import { SubNavigationBar } from '@/modules/shared/components'
import { faClose } from '@fortawesome/pro-light-svg-icons'
import React from 'react'
import { useSchedule, DAY_TYPE_TABS } from '../../context/ScheduleContext'

const DayTypesHeader = ({close}) => {
    const {formTab, setFormTab} = useSchedule()
  return (
    <div className="tw-ring-b tw-ring-base-100">
      <div className={`tw-flex tw-flex-col tw-gap-6 tw-py-4 tw-pb-0`}>
        <div className="tw-flex tw-items-center tw-justify-between tw-px-4">
          <div className="tw-flex tw-items-center tw-gap-2">
            <p className="tw-gap-2 tw-text-xl tw-font-semibold tw-text-content-base">
              Wybierz typ dnia
            </p>
          </div>
          <FaIcon
            icon={faClose}
            className="tw-h-5 tw-w-5 tw-cursor-pointer"
            onClick={() => close()}
          />
        </div>

        <SubNavigationBar>
          {DAY_TYPE_TABS.map((tab) => (
            <Navigation
              key={tab.type}
              isActive={formTab === tab.type}
              onClick={() => setFormTab(tab.type)}
            >
              {tab.label}
            </Navigation>
          ))}
        </SubNavigationBar>
      </div>
    </div>
  )
}

export default DayTypesHeader
